import React, { useState, useMemo, useContext } from 'react';
import { useTable } from 'react-table';
import moment from 'moment';
import { Text, Badge, Button, Checkbox } from '@mantine/core';
import { AppLoader } from '../../../../components/common/loader';
import { Styles } from '../../../../components/tables/skutable/production-site/styles';
import { ProductionLog } from '../productionSiteLogModal';
import { ActionModal } from '../actionModal';

export function EanApprovalTable({ data, save, actionModal, setActionModal, loading, readOnly }) {
  const [logModal, setLogModal] = useState({ open: false, id: '' });
  const [imp_id, setImp_id] = useState(0);
  const [otherStatus, setotherStatus] = useState({});

  function getLogs(data) {
    let impId = data.childIds || [];
    impId.push(data.id);
    impId = impId.join('_');

    setLogModal({ open: true, id: impId });
    setImp_id(impId);
  }
  const columns = useMemo(
    () => [
      {
        Header: 'New Material Code',
        Cell: ({ row }) => {
          return (
            <Text>
              {row.original.int_rfs_impl_material_creation.new_material_code
                ? row.original.int_rfs_impl_material_creation.new_material_code
                : 'N/A'}
            </Text>
          );
        },
      },
      {
        Header: 'New Material Description',
        Cell: ({ row }) => {
          return (
            <Text>
              {row.original.int_rfs_impl_material_creation.new_material_desc
                ? row.original.int_rfs_impl_material_creation.new_material_desc
                : 'N/A'}
            </Text>
          );
        },
      },
      {
        Header: 'Plant',
        Cell: ({ row }) => {
          return <Text>{row.original.int_rfs_material.plant}</Text>;
        },
      },
      {
        Header: 'Materials on BOM',
        Cell: ({ row }) => {
          return (
            <Badge
              color={
                row.original.material_on_bom === 'In Progress'
                  ? 'yellow'
                  : row.original.material_on_bom === 'Closed'
                  ? 'green'
                  : 'gray'
              }
              size='lg'
            >
              {row.original.material_on_bom}
            </Badge>
          );
        },
      },
      {
        Header: 'Status Change',
        Cell: ({ row }) => {
          return (
            <Badge
              color={
                row.original.status_change === 'In Progress'
                  ? 'yellow'
                  : row.original.status_change === 'Closed'
                  ? 'green'
                  : 'gray'
              }
              size='lg'
            >
              {row.original.status_change}
            </Badge>
          );
        },
      },
      {
        Header: 'Action',
        Cell: ({ row }) => {
          return row.original.status === 'In Progress' || row.original.status === 'Not Started' ? (
            <Checkbox
              onChange={() => {
                setotherStatus(row.original.id);
                setActionModal({ open: true, id: row.original.id });
              }}
              defaultChecked={false}
              label='Confirm and Close'
              disabled={row.original.status === 'Not Started' || readOnly}
            />
          ) : row.original.manually_closed && row.original.status === 'Closed' ? (
            <Text>Manual Closure</Text>
          ) : (
            <Text>Automatic Closure</Text>
          );
        },
      },
      {
        Header: 'Logs',
        Cell: ({ row }) => {
          return (
            <Button
              onClick={() => getLogs(row.original)}
              style={{ background: 'black', color: 'white' }}
            >
              View Logs
            </Button>
          );
        },
      },
      {
        Header: 'Step Deadline',
        Cell: ({ row }) => {
          return <Text>{moment(row.original.sla_date).format('YYYY-MM-DD')}</Text>;
        },
      },
      {
        Header: 'Step Finished',
        Cell: ({ row }) => {
          return (
            <Text>
              {row.original.finished_date
                ? moment(row.original.finished_date).format('YYYY-MM-DD')
                : row.original.status}
            </Text>
          );
        },
      },
    ],
    [],
  );

  const tableInstance = useTable({
    columns,
    data,
  });

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = tableInstance;

  return (
    <Styles>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: 'fitContent' }} {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()} id='header-row'>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {actionModal && (
        <ActionModal
          actionModal={actionModal}
          setActionModal={setActionModal}
          save={save}
          status_id={otherStatus}
          updateLoading={loading}
        />
      )}

      {logModal && (
        <ProductionLog
          logModal={logModal}
          id={imp_id}
          setLogModal={setLogModal}
          type='EAN Approval'
        />
      )}
    </Styles>
  );
}
